(function View($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('PrimaryGoals/view', function onload() {
			var id = $('#goal-id').val();
			loadChart(id);
		});
	});

	function loadChart(id)
	{
		Adzuki.Ajax.get('/PrimaryGoals/check/' + id)
		.then(function getChartData(response)
		{
			if (response.error) {
				Adzuki.StatusMessage(null, response.error, 'Error');
				return;
			}

			$('#chart').html(response);
		});
	}
}(jQuery, window.Adzuki || {}));
